module.exports = __webpack_public_path__ + "static/sport/bgi-dialog-h5.d09b1ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/road/bgi-dialog-h5.png
// module id = +Jrp
// module chunks = 0